import * as React from 'react';
import { Avatar } from '@mui/material';
import { useRecordContext } from 'react-admin';

import { Account } from '../types';

export const AccountAvatar = (props: {
    record?: Account;
    width?: number;
    height?: number;
}) => {
    const { width = 40, height = 40 } = props;
    const record = useRecordContext<Account>(props);
    if (!record) return null;
    return (
        <Avatar
            src={record.logo?.src}
            alt={record.name}
            sx={{
                '& img': { objectFit: 'contain' },
                width,
                height,
                fontSize: height !== 40 ? '0.6rem' : undefined,
                '&.MuiAvatar-colorDefault': {
                    backgroundColor: '#ecfdf5',
                    color: '#047857',
                    fontWeight: 600,
                },
            }}
        >
            {record.name.charAt(0)}
        </Avatar>
    );
};
